export const TID = {
  // Nav
  navLogo: "nav-logo",
  navLink: (key) => `nav-link-${key}`,
  langToggle: "lang-toggle",
  langOption: (lng) => `lang-option-${lng}`,
  navLogin: "nav-login",
  navRegister: "nav-register",
  navDashboard: "nav-dashboard",
  navLogout: "nav-logout",

  // Home
  heroHeadline: "hero-headline",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",
  howStep: (i) => `how-step-${i}`,
  categoryCard: (slug) => `category-card-${slug}`,
  assessmentCta: "assessment-cta",

  // Guides
  guidesGrid: "guides-grid",
  guideCard: (slug) => `guide-card-${slug}`,
  guidePurchaseBtn: "guide-purchase-btn",

  // Assessment
  assessmentStart: "assessment-start",
  assessmentInput: (i) => `assessment-input-${i}`,
  assessmentNext: "assessment-next",
  assessmentPrev: "assessment-prev",
  assessmentSubmit: "assessment-submit",
  assessmentReport: "assessment-report",

  // Auth
  authEmail: "auth-email",
  authPassword: "auth-password",
  authName: "auth-name",
  authSubmit: "auth-submit",
  authError: "auth-error",

  // Dashboard
  dashboardWelcome: "dashboard-welcome",
};
